export default () => ({
  isContentLoaded: false,
  headerContent: {},
  descriptionContent: {},
  confirmContent: {},
});
